/**
 * Test IDs for QA automation.
 */
export const testIds = {
  subscriptionInfoBannerManage: "subscription-info-banner-manage",
} as const;
